import PropTypes from 'prop-types';
import { Outlet } from 'react-router-dom';
import { ConfirmProvider } from '@/ui';
import ReceptorNav from './ReceptorNav.jsx';
import './ReceptorLayout.css';

export default function ReceptorLayout({ children, preview = false }) {
  return (
    <ConfirmProvider>
      <div className="rx-shell receptor-shell">
        <div className="rx-main receptor-main">{children ?? <Outlet />}</div>
        <ReceptorNav preview={preview} />
      </div>
    </ConfirmProvider>
  );
}

ReceptorLayout.propTypes = {
  children: PropTypes.node,
  preview: PropTypes.bool,
};
